export default {
  path: '/package',
  meta: { layout: { subPage: true } },
  component: () => import('@/layout/Empty.vue'),
  children: [
    {
      path: 'buy',
      name: 'packageBuy',
      meta: { title: '购买套餐' },
      component: () => import('@/views/user/fee/PackageBuy')
    },
    {
      path: 'pay/:orderNo',
      name: 'packagePay',
      meta: { title: '购买套餐' },
      props: true,
      component: () => import('@/views/user/fee/PackagePay')
    },
    {
      path: 'done/:orderNo',
      name: 'packageDone',
      props: true,
      meta: { title: '购买套餐' },
      component: () => import('@/views/user/fee/PackageDone')
    }
  ]
}
